export const MINISTRY_TIME_ZONE = 'America/Antigua';

export function ministryDateKey(value) {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: MINISTRY_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(new Date(value));
    const part = type => parts.find(p => p.type === type).value;
    return `${part('year')}-${part('month')}-${part('day')}`;
}

// A local noon anchor lets the calendar lay out Antigua dates in any browser timezone.
export function calendarDate(value) {
    const [year, month, day] = ministryDateKey(value).split('-').map(Number);
    return new Date(year, month - 1, day, 12);
}

export function formatMinistryDate(value, options = { year: 'numeric', month: 'long', day: 'numeric' }) {
    return new Intl.DateTimeFormat('en-US', { ...options, timeZone: MINISTRY_TIME_ZONE }).format(new Date(value));
}

export function eventOccursOn(event, date) {
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    return key >= ministryDateKey(event.startDate) && key <= ministryDateKey(event.endDate || event.startDate);
}

export function formatEventSchedule(event) {
    const time = { hour: 'numeric', minute: '2-digit' };
    const start = event.dateLabel || formatMinistryDate(event.startDate, {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', ...time,
    });
    if (!event.endDate) return start;
    const sameDay = ministryDateKey(event.startDate) === ministryDateKey(event.endDate);
    const end = event.dateLabel ? formatMinistryDate(event.endDate)
        : formatMinistryDate(event.endDate, sameDay ? time : { year: 'numeric', month: 'long', day: 'numeric', ...time });
    return `${start} – ${end}`;
}

export function ministryInputToISO(value) {
    if (!value) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(`${value}T00:00:00-04:00`).toISOString();
    // datetime-local inputs represent the ministry's event time, not the editor's timezone.
    const zoned = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(value) ? `${value}-04:00` : value;
    return new Date(zoned).toISOString();
}
